export enum RmRackPositionTypeEnum {
    FRONT = "front",
    REAR = "rear"
}